import * as React from 'react';
/**
 *
 * Original name: fail
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=23439%3A2797
 *
 */
export const FailPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m21.353 39.819 9.192-9.193 9.193-9.192 2.828 2.828-18.385 18.385-2.828-2.828Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m24.181 21.353 18.385 18.385-2.828 2.828-18.385-18.385 2.828-2.828Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.832 47.168c2.93 2.93 7.693 4.747 15.168 4.747s12.237-1.817 15.168-4.747c2.93-2.93 4.747-7.693 4.747-15.168s-1.817-12.237-4.747-15.168c-2.93-2.93-7.693-4.747-15.168-4.747s-12.237 1.817-15.168 4.747c-2.93 2.93-4.747 7.693-4.747 15.168s1.817 12.237 4.747 15.168ZM8 32c0 16.15 7.85 24 24 24s24-7.85 24-24S48.15 8 32 8 8 15.85 8 32Z", fill: "currentColor" })));
